module.exports = __webpack_public_path__ + "static/media/linkedin-white.8c7cace9.svg";